/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import ReactDOM from 'react-dom'
import newStore from './store'
import { hashHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { writeCardSize } from './actions/game'
// import 'react-toolbox/lib/commons.scss'

import AppProvider from './AppProvider'
import moment from 'moment'
import { ContextualIntlProvider } from './nls'
import './index.css'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { LEVELS, log } from './logs'
/*
import { install as installOfflineHandling } from 'offline-plugin/runtime'
installOfflineHandling()
*/

if (navigator.languages && navigator.languages.length) {
  moment.locale(navigator.languages[0])
}
const store = newStore()
const history = syncHistoryWithStore(hashHistory, store)
/* history.listen(function (location) {
  const path = (/#(\/.*)$/.exec(location.hash) || [])[1]
  if (path) history.replace(path)
}) */

window.addEventListener('resize', () => {
  const { settings: { matchCount, cardCount } } = store.getState()
  const size = writeCardSize(matchCount, cardCount)
  log('window', LEVELS.DEBUG, size)
})

ReactDOM.render(
  <ContextualIntlProvider>
    <AppProvider store={store} history={history} />
  </ContextualIntlProvider>,
  document.getElementById('root')
)

if (module.hot) {
  module.hot.accept()
}
